import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { InventoryService } from './inventory.service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  UserData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  LanguageChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public languages: string[] = ['en', 'es', 'de', 'it', 'ru'];
  subs: Subscription = new Subscription
  constructor(public translate: TranslateService,private CommonService: CommonService, private cookieService: CookieService,private inventory: InventoryService) {
    let browserLang;
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      // browserLang = this.cookieService.get('lang');
      if(sessionStorage.getItem('lang')==null){
        sessionStorage.setItem('lang', 'en');
      }
      browserLang = sessionStorage.getItem('lang')
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/en|es|de|it|ru/) ? browserLang : 'en');
    
  }

  public setLanguage(lang) {
    console.log(lang,"1111");
    
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
    sessionStorage.setItem('lang', lang);
  }
  
}
